// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"pv-z","giftOrPromoSelector":"qv-z","disabled":"rv-z","subTitle":"sv-z","selectShipAddressMessage":"tv-z","changePayment":"uv-z"};